export default __webpack_public_path__ + "static/media/step-two-strain.f2713f33.jpg";